/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import {GenericModelViewerListNode} from "../../../Components/Common/GenericModelViewerListNode";
import {MutableList} from "../../../Components/Common/MutableList";
import {NonMutableList} from "../../../Components/Common/NonMutableList";
import {OrderableMutableList} from "../../Extensions/Core/OrderableMutableList";
import {GuidUtils, ObjectUtils} from "../../../Utils";
import React from "react";

export class ChildrenFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)
	}

	@autobind
	getPKName() {
		let model = this.props.FieldDef.association.model;
		let pk = model.getPrimaryKeyName();
		return pk;
	}

	@autobind
	_render() {
		let list = {
			component: MutableList
		};
		if (this.props.FieldDef.association.orderable) {
			list.component = OrderableMutableList;
		}
		if (this.props.FieldDef.association.nonMutable) {
			list.component = NonMutableList;
		}
		if (this.props.FieldDef.association.listComponentOverride) {
			list.component = this.props.FieldDef.association.listComponentOverride;
		}

		return <list.component
			Editable={true}
			DataTypeName={this.props.FieldDef.title}
			Data={this.props.Value}
			Type={GenericModelViewerListNode}
			AdditionalTypeProps={{
				RootData: this.props.RootData,
				FieldDef: this.props.FieldDef,
				Editable: true,
				OnValidationUpdate: this.props.OnValidationUpdate,
				CustomData: {...this.props.CustomData, ...this.props.FieldDef.association.customData}
			}}
			PrimaryKeyName={this.getPKName()}
			GetItemTitle={(x) => {
				let pk = this.getPKName();
				return x["name"] || (x[pk] != null ? (this.props.FieldDef.title + " " + x[pk]) : ("New " + this.props.FieldDef.title));
			}}
			GetItemKey={(x) => {
				let pk = this.getPKName();
				return x[pk] || x._tempId;
			}}
			GetSortKey={() => {
				return this.props.FieldDef.association.sortKey ?? this.props.FieldDef.association.orderable;
			}}
			UpdateItems={this.props.OnUpdate}
			UpdateItem={(key, value) => {
				let pk = this.getPKName();
				let newValue = [];

				if (this.props.Value) {
					newValue = ObjectUtils.Clone(this.props.Value);
				}

				let old = newValue.find((x) => x[pk] == key);
				if (!old) {
					old = newValue.find((x) => x._tempId == key);
				}

				let idx = newValue.indexOf(old);

				newValue[idx] = value;

				this.props.OnUpdate(newValue);
			}}
			AddItem={(item = null) => {
				const {OnUpdate, Value, FieldDef} = this.props;

				let newItem = item ?? FieldDef.model?.defaults ?? FieldDef.association.model?.defaults ?? {};
				let newValue = [];

				if (Value) {
					newValue = ObjectUtils.Clone(Value);
				}

				newItem._tempId = GuidUtils.Generate();

				if (FieldDef.association.orderable) {
					let maxOrder = 0;
					if (Value) {
						Value.forEach((x) => {
							if (x[FieldDef.association.orderable] > maxOrder) {
								maxOrder = x[FieldDef.association.orderable];
							}
						});
					}

					newItem[FieldDef.association.orderable] = ++maxOrder;
				}

				newValue.push(newItem);

				OnUpdate(newValue);
			}}
			RemoveItem={(key) => {
				let pk = this.getPKName();
				let newValue = [];

				if (this.props.Value) {
					newValue = ObjectUtils.Clone(this.props.Value);
				}

				let old = newValue.find((x) => x[pk] == key);
				if (!old) {
					old = newValue.find((x) => x._tempId == key);
				}

				let idx = newValue.indexOf(old);

				newValue.splice(idx, 1);
				this.props.OnUpdate(newValue);
			}}
		/>;
	}
}